module.exports = __webpack_public_path__ + "static/media/Beryl Cong.752a0694.png";